module.exports = __webpack_public_path__ + "media/25.5c6a351d.mp3";